// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"U7-z"};